<div class="federated-modal">
  <div class="modal-content text-center">
    <div class="modal-body">
      <h1 class="font-light weight mb-4 default lh-40">Your employer has a different sign up process.</h1>
    </div>
    <div class="pt-3 modal-footer">
      <button name="cancelButton" aria-label="Close" (click)="close()"
          class="btn btn-primary btn-block mt-0">Got it</button>
    </div>
  </div>
</div>
